import { formatDisplayRating } from "./gmbReviewHelpers";

export function buildLocalBusinessSchema({
  aggregateRating,
  ratingCount,
}) {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Restoration Roofing & Remodeling",
    url: "https://restorationroofingremodeling.com/",
    telephone: "(832) 388-5393",
    address: {
      "@type": "PostalAddress",
      streetAddress: "6902 fm 2920, Suite 2",
      addressLocality: "Spring",
      addressRegion: "TX",
      postalCode: "77379",
      addressCountry: "US",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 30.0749063,
      longitude: -95.5282125,
    },
    sameAs: "https://www.instagram.com/restoration_roofing_remodeling/",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: formatDisplayRating(aggregateRating),
      bestRating: "5",
      ratingCount: String(ratingCount),
    },
  };
}
